import type { ConcedeAction } from "../types/actions";
import type { KineticCoreState } from "../types/game-state";
import { getOpponentId } from "../utils/participant-helpers";

export function applyConcede(
  state: KineticCoreState,
  action: ConcedeAction,
): KineticCoreState {
  return {
    ...state,
    phase: "ENDED",
    winner: getOpponentId(state.participants, action.participantId),
    outcomeReason: "CONCEDE",
    isDraw: false,
  };
}
